export enum DeeplinkKind {
  SocialShare = 'socialShare',
  Task = 'task',
  ProjectJson = 'projectJson',
  Preset = 'preset',
  Category = 'category',
  Tool = 'tool',
  None = 'none',
}

export type Deeplink =
  | { kind: DeeplinkKind.SocialShare; fileUrl: string }
  | { kind: DeeplinkKind.Task; taskId: string }
  | { kind: DeeplinkKind.ProjectJson; jsonUrl: string }
  | {
      kind: DeeplinkKind.Preset;
      presetId: string;
      category?: string;
      openChooser?: boolean;
    }
  | {
      kind: DeeplinkKind.Category;
      category: string;
      /**
       * Open the category's full "See all" grid instead of pinning its row to
       * the top of the feed. Opt-in, because pinning is the established
       * behaviour of a bare `genaicategory` link — see `categoryHandler`.
       */
      seeAll?: boolean;
    }
  | { kind: DeeplinkKind.Tool; tool: string }
  | { kind: DeeplinkKind.None };
